<template>
  <div>
    <fo-header
      selected="/about"
      @selected="(e) => {}">
    </fo-header>
    <template v-for="(item, ind) in modelData">
      <component
        v-bind:is="item.model_name"
        :key="ind"
        :itemData="item">
      </component>
    </template>
    <fo-footer></fo-footer>
  </div>
</template>

<script>
import about from './Models/aboutb.vue'
import majorEvent from './Models/majorEvent.vue'
import missionAndVision from './Models/missionAndVision.vue'
import honor from './Models/honor.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    about,
    majorEvent,
    missionAndVision,
    honor
  },
  computed: mapGetters([
    'commonData'
  ]),
  data () {
    return {
      modelData: [
        {
          title: '融英律师事务所',
          sub_title: '山川融合 聚华含英',
          model_name: 'about',
          visible: true
        // }, {
        //   title: '大事记',
        //   sub_title: '融英律所的重要事件',
        //   model_name: 'majorEvent',
        //   visible: true
        // }, {
        //   title: '使命愿景',
        //   sub_title: '融英律所的期望',
        //   model_name: 'missionAndVision',
        //   visible: true
        // }, {
        //   title: '律所荣誉',
        //   sub_title: '我们获得的肯定',
        //   model_name: 'honor',
        //   visible: true
        }
      ]
    }
  },
  watch: {
    'commonData.web_pages' (obj) {
      const page = JSON.parse(obj.value).filter(item => item.value === this.$route.path)
      if (page.length) {
        this.modelData = page[0].children.filter(model => model.visible)
      }
    }
  },
  mounted () {
    if (this.commonData.web_comp_intro.value) {
      const page = JSON.parse(this.commonData.web_pages.value).filter(item => item.value === this.$route.path)
      if (page.length) {
        this.modelData = page[0].children.filter(model => model.visible)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/About.vue